import React from 'react';

class KioskApps extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kiosk applications</div>
        </div>

        <div className='version-block'>
          {renderAppInfo(hostInfo, 'printapi')}
          {renderAppInfo(hostInfo, 'payapi')}
          {renderAppInfo(hostInfo, 'capui')}
          {renderAppInfo(hostInfo, 'provisioner')}
          {/*{renderAppInfo(hostInfo, 'mm')}*/}
          {renderAppInfo(hostInfo, 'kskapi')}
          {renderAppInfo(hostInfo, 'cafeapi')}
          {renderAppInfo(hostInfo, 'heatwave')}
          {renderAppInfo(hostInfo, 'ciscoampconnector')}
          {renderAppInfo(hostInfo, 'cortexAgent')}
        </div>
      </div>
    );
  }
}

function renderAppInfo(hostInfo, appName) {
  let kioskInfo = hostInfo.kioskInfo || {};
  let basicInfo = hostInfo.basicInfo || {};
  let app = kioskInfo[appName] || {};
  if (appName === 'ciscoampconnector') {
    app = basicInfo[appName] || {};
  }
  let appVersion = app.version;
  let appStatus = app.status || '';
  let appRunning = /^Running/.test(appStatus);
  if (appVersion) {
    return (
      <div className='pure-g'>
        <div className='pure-u-6-24' style={{ color: appRunning ? '' : 'darkred' }}>
          <i
            className={appRunning ? 'fa fa-fw fa-plug app-running' : 'fa fa-fw fa-plug app-stopped'}
          />
          {appName}
        </div>
        <div className='pure-u-8-24' style={{ color: appRunning ? '' : 'darkred' }}>
          {appVersion}
        </div>
        <div className='pure-u-10-24 status' style={{ color: appRunning ? '' : 'darkred' }}>
          {appStatus}
        </div>
      </div>
    );
  }
  return null;
}

export default KioskApps;



// WEBPACK FOOTER //
// ./src/components/KioskApps.js